
const AboutImplant = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Luxury background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(251,191,36,0.1),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(245,158,11,0.1),transparent_50%)]"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 backdrop-blur-sm border border-amber-400/30 rounded-full px-6 py-3 mb-6">
            <div className="w-2 h-2 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-full animate-pulse"></div>
            <span className="text-amber-300 font-medium text-sm">ABOUT IMPLANT</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-white via-amber-100 to-white bg-clip-text text-transparent">
              入れ歯やブリッジとは違う、
            </span>
            <br />
            <span className="bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 bg-clip-text text-transparent">
              画期的な治療法
            </span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-8 border border-amber-400/20">
              <h3 className="text-2xl font-bold text-amber-400 mb-6 flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-information-line text-slate-900 text-sm"></i>
                </div>
                <span>インプラント治療とは</span>
              </h3>
              
              <p className="text-slate-300 leading-relaxed text-lg mb-6">
                インプラント治療は、入れ歯やブリッジとは違い、<span className="text-amber-300 font-semibold">他の歯に負担をかけることのない</span>、最新の治療法です。従来の治療法では少なからず周囲の歯に固定源を求める必要があり、総入れ歯を除き、残った歯にダメージを与えていました。
              </p>
              
              <p className="text-slate-300 leading-relaxed text-lg">
                しかしインプラントは、固定源として顎の骨を利用しており、更にインプラント体をチタンで作ることで骨と一体化することに成功したため、残った歯に影響を与えることなく歯を作ることができるようになったのです。
              </p>
            </div>

            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-8 border border-amber-400/20">
              <h3 className="text-2xl font-bold text-amber-400 mb-6 flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-settings-line text-slate-900 text-sm"></i>
                </div>
                <span>インプラント治療の仕組み</span>
              </h3>
              
              <div className="space-y-4">
                <h4 className="text-xl font-semibold text-white">インプラントはどんな構造をしているの？</h4>
                
                <div className="space-y-3 text-slate-300 leading-relaxed">
                  <p>骨の中に埋め込む（埋入と言います）<span className="text-amber-300 font-semibold">「インプラント体」</span></p>
                  <p>歯茎の上の見える部分である<span className="text-amber-300 font-semibold">「上部構造」</span></p>
                  <p>その2つを繋ぎ、土台となる<span className="text-amber-300 font-semibold">「アバットメント」</span></p>
                  <p>この3つを組み合わせるのに<span className="text-amber-300 font-semibold">「スクリュー」</span>と呼ばれる特殊なネジを使用します。</p>
                </div>
                
                <div className="mt-6 p-4 bg-amber-500/10 rounded-2xl border border-amber-400/30">
                  <h4 className="text-lg font-semibold text-amber-300 mb-2">インプラントはなぜ動かないの？</h4>
                  <p className="text-slate-300 leading-relaxed">
                    骨の中に埋め込む「インプラント体」という特殊なネジは、チタンでできています。1960年代、チタンと骨が結合する<span className="text-amber-300 font-semibold">「オッセオインテグレーション」</span>という現象が発見されました。これにより、骨とインプラント体がしっかりと固定されるため、インプラントはほとんど動かないのです。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Image and Structure */}
          <div className="space-y-8">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/bc57986010855907214957a215c129a5.jpg"
                alt="インプラントの構造"
                className="w-full h-auto rounded-3xl shadow-2xl"
              />
              
              {/* Floating info cards */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-br from-amber-400 to-yellow-500 p-4 rounded-2xl shadow-xl">
                <div className="text-slate-900 font-bold text-sm">チタン製</div>
                <div className="text-slate-900 text-xs">生体親和性</div>
              </div>
            </div>

            {/* Comparison Table */}
            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-8 border border-amber-400/20">
              <h3 className="text-2xl font-bold text-amber-400 mb-6 text-center">
                インプラント治療が選ばれる理由
              </h3>
              
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-amber-400/30">
                      <th className="text-left py-3 text-slate-300"></th>
                      <th className="text-center py-3 text-amber-300 font-semibold">インプラント</th>
                      <th className="text-center py-3 text-slate-400">義歯</th>
                      <th className="text-center py-3 text-slate-400">ブリッジ</th>
                    </tr>
                  </thead>
                  <tbody className="text-slate-300">
                    <tr className="border-b border-slate-700/50">
                      <td className="py-3 font-medium">隣り合った歯へのダメージ</td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-close-line text-red-400 text-xl"></i>
                      </td>
                    </tr>
                    <tr className="border-b border-slate-700/50">
                      <td className="py-3 font-medium">噛む力</td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-subtract-line text-yellow-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                    </tr>
                    <tr className="border-b border-slate-700/50">
                      <td className="py-3 font-medium">違和感</td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-close-line text-red-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="py-3 font-medium">治療期間</td>
                      <td className="text-center py-3">
                        <i className="ri-subtract-line text-yellow-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-green-400 text-xl"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-amber-500/20 to-yellow-500/20 backdrop-blur-sm rounded-3xl p-8 border border-amber-400/30">
            <p className="text-2xl font-bold text-amber-300 mb-4">
              インプラントは条件が揃えば、どんな欠損補綴よりも咬合力を回復することができます。
            </p>
            <p className="text-slate-300 text-lg">
              ゆうまデンタルクリニックでは、患者様一人ひとりに最適な治療をご提案いたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutImplant;
